import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 9a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3l0 -6","key":"svg-0"}],["path",{"d":"M9 18v3h6v-3","key":"svg-1"}],["path",{"d":"M9 6v-3h6v3","key":"svg-2"}],["path",{"d":"M12 10a2 2 0 1 0 2 2","key":"svg-3"}]]

const IconDeviceWatchStats2 = createReactComponent('outline', 'device-watch-stats-2', 'DeviceWatchStats2', __iconNode);

export default IconDeviceWatchStats2;